import { createContext, useReducer } from "react";

export const HumanContext = createContext();

export const humanReducer = (state, action) => {
    switch (action.type) {
        case 'SET_HUMAN':
            return {
                human: action.payload
            }
        case 'CREATE_HUMAN':
            return {
                human: [action.payload, ...state.human]
            }
        case 'DELETE_HUMAN':
            return {
                human: state.human.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const HumanContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(humanReducer, {
        human: null
    });

    return (
        <HumanContext.Provider value={{ ...state, dispatch }}>
            {children}
        </HumanContext.Provider>
    );
};